import { useNavigate } from 'react-router-dom'

import { CategoryFormComponent } from '../../components/CategoryForm'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'

import { useControlSearchCategories } from '../../hooks/useControlSearchCategories'
import { useSimpleState } from '../../hooks/useSimpleState'

const CreateCategoryPage = () => {
    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false
    })

    const {_state: _errors} = useSimpleState({})

    const {_control} = useControlSearchCategories()

    const handleSubmit = (body) => {
        _state.set('fetching', true)

        _control.fetchCreate(body).then(res => {
            if (res.status === 200) {
                navigate('/categories')
            } else {
                _errors.set(res.errors?.errors || {})
            }
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    return (
        <div>
            <LayoutPage config={{ id: 'ManageDeals' }}>
                <PageTitleComponent value="Create Category" />

                <div className={_state.get('fetching') ? 'disabled' : ''}>
                    <CategoryFormComponent config={{
                        errors: _errors.get()
                    }} events={{
                        handleSubmit: handleSubmit
                    }} />
                </div>
            </LayoutPage>
        </div>
    )
}

export { CreateCategoryPage }
